// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupContentPreview_wrapper__iwc9v","bar":"PopupContentPreview_bar__2eP3I"};